import React from "react";
import { connect } from "react-redux";
import styles from "./style";
import { css } from "aphrodite";

class Paginator extends React.Component {
  prevAction = () => {
    const { currentPage } = this.props;
    const prevpage = currentPage > 1 ? currentPage - 1 : currentPage;
    this.props.changePage(prevpage);
  };

  nextAction = () => {
    const { currentPage, perPage, pages } = this.props;
    let totalPages = 0;
    if(pages !== 0){
      totalPages = pages;
    }

    if (currentPage < totalPages) {
      this.props.changePage(currentPage + 1);
    }
  };

  renderPerPage = () => {
    const { actionPerPage = null, perPage = "20" } = this.props;

    return (
      <div
        className={css(styles.divSelectPagination)}
        style={{ color: "#FFF" }}
      >
        <select
          name="perpage"
          className={css(styles.paginationSelect)}
          onChange={(e) => actionPerPage(e.currentTarget.value)}
          value={perPage}
        >
          <option value="5" selected={perPage === "5" ? true : false}>
            5
          </option>
          <option value="10" selected={perPage === "10" ? true : false}>
            10
          </option>
          <option value="20" selected={perPage === "20" ? true : false}>
            20
          </option>
          <option value="50" selected={perPage === "50" ? true : false}>
            50
          </option>
          <option value="100" selected={perPage === "100" ? true : false}>
            100
          </option>
        </select>
        {/* <div className={css(styles.divPaginationArrow)}>
            <img
              src="/images/header/pagination_dropdown_black_arrow.png"
              alt="pagination"
              title="pagination"
            />
          </div> */}
      </div>
    );
  };

  renderPages = () => {
    const { perPage, currentPage, totalPage = this.props.pages } = this.props;
    let totalPages = 0;

    if(totalPage !== 0){
      totalPages = totalPage;
    }

    let pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(this.addedPages(i, currentPage));
      }
    } else {
      pages.push(this.addedPages(1, currentPage));

      if (currentPage > 3) {
        pages.push(
          <span className={css(styles.dotsPagination)}>{"..."}</span>
        );
      }

      // special case where last page is selected...
      // Without this special case, only 2 buttons would be shown after ... if you were on last page
      if (currentPage === totalPages) {
        pages.push(this.addedPages(currentPage - 2, currentPage));
      }

      // Print previous number button if currentPage > 2
      if (currentPage > 2) {
        pages.push(this.addedPages(currentPage - 1, currentPage));
      }

      //Print current page number button as long as it not the first or last page
      if (currentPage !== 1 && currentPage !== totalPages) {
        pages.push(this.addedPages(currentPage, currentPage));
      }

      //print next page number button if currentPage < lastPage - 1
      if (currentPage < totalPages - 1) {
        pages.push(this.addedPages(currentPage + 1, currentPage));
      }

      // special case where first page is selected...
      // Without this special case, only 2 buttons would be shown before ... if you were on first page
      if (currentPage === 1) {
        pages.push(this.addedPages(currentPage + 2, currentPage));
      }

      //print "..." if currentPage is < lastPage -2
      if (currentPage < totalPages - 2) {
        pages.push(
          <span className={css(styles.dotsPagination)}>{"..."}</span>
        );
      }

      //Always print last page button if there is more than 1 page
      if (totalPages > 1) {
        pages.push(this.addedPages(totalPages, currentPage));
      }
    }
    return pages.map((val) => val);
  };

  addedPages = (number, currentPage) => {
    return (
      <span
        key={number}
        className={css(
          currentPage === number
            ? styles.itenPaginationActive
            : styles.itenPagination
        )}
        onClick={() => this.props.changePage(number)}
      >
        {number}
      </span>
    );
  };

  renderBlock = () => {
    const { perPage, totalRecords, currentPage, pages, showPerPage = true } = this.props;
    let totalPages = 0;
    if(pages !== 0){
      totalPages = pages;
    }
    // console.log("totalPages....",totalPages)
    if (totalPages > 1) {
      return (
        <div className={css(styles.pagination)}>
          <img
            title="Previous"
            alt="left"
            src="/images/pagination_arrow_left.png"
            className={css(styles.arrow)}
            onClick={() => this.prevAction()}
          />
          {this.renderPages()}
          <img
            title="Next"
            alt="right"
            src="/images/pagination_arrow_right.png"
            className={css(styles.arrow)}
            onClick={() => this.nextAction()}
          />
          {showPerPage && this.renderPerPage()}
        </div>
      );
    } else {
      return (
        <div className={css(styles.pagination)}>{this.renderPerPage()}</div>
      );
    }
  };

  render() {
    //console.log('PAGE HERE', this.props.page);
    return this.renderBlock();
  }
}

export default connect(
  (store) => {
    return {};
  },
  (dispatch) => {
    return {};
  }
)(Paginator);
